export default {
  pay: "Payer",
  acceptTermsAndConditions: "Accepter les termes et conditions",
  selectYourCard: "SÉLECTIONNEZ VOTRE CARTE",
  yourOrder: "VOTRE COMMANDE",
  generalPlaceHolderNotes:
    "Vous pouvez supprimer des ingrédients, vous ne pouvez pas ajouter ou modifier",
  placeholderNotesDrinks: "Commentaires ...",
  placeholderNotesFood: "Commentaires ...",
  total: "TOTALE:",
  totalToPay: "Total à payer:",
  paymentConfirmation: "Confirmation de paiement",
  paymentRequest: "Vous avez demandé le paiement de :",
  payCash: "Payer en argent comptant",
  yourOrderIsInProgress: "Votre commande est en cours,",
  itWillReachYou: "il t'atteindra",
  desk: "bureau",
  paymentMethod: "MODE DE PAIEMENT",
  dataphone: "Téléphone de données",
  smartphone: "téléphone intelligent",
  howDoYouWantToPay: "Comment voulez-vous payer?",
  creditOrDebitCard: "carte de crédit ou de débit",
  missingPay: "Paie manquante:",
  petitionRejected: "Pétition rejetée",
  redirectingToThePaymentprocess: "Redirection vers le processus de paiement",
  addNewCard: "Ajouter une nouvelle carte",
  paymentMade: "Paiement effectué",
  receiptOfYourPaymentTo: "Réception de votre paiement à"
};
